<div class="wrapper">
<appv2-header class="header-sticky"></appv2-header>
<router-outlet></router-outlet>
<appv2-footer></appv2-footer>
</div>